import { Stack } from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";
import { useThemeMode } from "@src/appV2/UserPreferences/UserPreferencesProvider";

import { AccountSwitcherMobile } from "../AccountSwitcher/AccountSwitcher";
import { WorkplaceContextTitle } from "../../Shared/Header/WorkplaceContextTitle";

export interface NavigationMenuHeaderMobileProps {
  onClose: () => void;
}

export function NavigationMenuHeaderMobile(props: NavigationMenuHeaderMobileProps) {
  const { onClose } = props;
  const isRebrand = useIsRebrand();
  const { themeMode } = useThemeMode();
  const { profile } = useSession();
  const isDark = themeMode === "dark";
  const closeVariant = isRebrand && !isDark ? "link" : "outlineInverted";
  const showWorkplaceTitle = Boolean(profile?.name);

  return (
    <Stack direction="column" gap={2} flexGrow={0} flexShrink={0} sx={{ paddingBottom: 2 }}>
      {/* Title row: workplace context (or empty) + close. Acts as the drawer's
          header, similar to native mobile screen headers. */}
      <Stack direction="row" alignItems="center" gap={3}>
        <Stack flex={1} minWidth={0}>
          {showWorkplaceTitle && <WorkplaceContextTitle />}
        </Stack>
        <IconButton
          variant={closeVariant}
          iconType="close"
          size="large"
          aria-label="Close menu"
          onClick={onClose}
          sx={{ border: "none", aspectRatio: "1", flexShrink: 0 }}
        />
      </Stack>

      {/* Primary action: search (admin) or account avatar (non-admin) */}
      <AccountSwitcherMobile />
    </Stack>
  );
}
